module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.0a9ad0dd.webp";